// External dependencies
import React from "react";
import { Provider } from "react-redux";
import configureStore from "./config/store";
import Main from "./components/Main/view";
import { getStylesFromAV2, isIframe } from "helpers/isIframe";

const { store, history } = configureStore();

const loadStyleSheet = () => {
  const getStyle = getStylesFromAV2()
  if(getStyle && isIframe) { // style exists and is in an iframe
    const style = document.createElement('style');
    style.textContent = getStyle;
    document.head.append(style);
  }
}

//Application root component
class App extends React.Component {

  componentDidMount() {
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyAUExpQhPB2_gwK8fL9KBmNO_33qXJkQnQ&libraries=places";
    script.async = true;
    document.body.appendChild(script);

    loadStyleSheet();
  }

  /* 
  AmiOnTheRightPage(iframe_path){
      const reduxStore = store.getState()
      switch(iframe_path){
        case '/siniestros':
          return reduxStore.siniestro.filtrosTablaSiniestro && 
          reduxStore.siniestro.filtrosTablaSiniestro.length && !reduxStore.siniestro.isLoading 
        case '/plan-movilidad':
          return reduxStore.planMovilidad.inicioMenuTabs && 
          reduxStore.planMovilidad.inicioMenuTabs.length && !reduxStore.planMovilidad.isLoading 
        case '/siniestros-empresa':
          return reduxStore.router.location.pathname === iframe_path && !reduxStore.siniestroEmpresa.isLoading 
        case '/cotizaciones':
          return reduxStore.router.location.pathname === iframe_path 
        case '/contact-center':
          return reduxStore.router.location.pathname === iframe_path && reduxStore.header.tabs && reduxStore.header.tabs.length && !reduxStore.contactCenter.isLoading 
        case '/empresas-achs':
          return reduxStore.router.location.pathname === iframe_path && reduxStore.header.tabs && reduxStore.header.tabs.length && !reduxStore.empresasAutoasignadas.isLoading 
        default:
        return false
    }
  } */
  render() {
    return (
      <>
        {/* {process.env.REACT_APP_ENV === 'development' && (
          <>
            <p style={{ wordWrap: "break-word", width: "80%", height: "20%" }}>{JSON.stringify(localStorage)}</p>
            <br />
          </>
        )} */}
        <Provider store={store}>
          <Main history={history} />
        </Provider>
      </>
    );
  }
}

export default App;
